module.exports = __webpack_public_path__ + "media/images/logos/f_logo-3ca53be77284ac969b6f61abdb669d93.png";